(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["storage-anniversary"] && !Shopify.designMode) return;
  try {
    
(() => {
  const setupCampaign = (scope) => {
    scope.querySelectorAll('[data-campaign-track]').forEach((track) => {
      if (track.dataset.campaignBound) return;
      track.dataset.campaignBound = 'true';
      let pointer = null;
      let originX = 0;
      let originScroll = 0;
      track.addEventListener('pointerdown', (event) => {
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        pointer = event.pointerId;
        originX = event.clientX;
        originScroll = track.scrollLeft;
        track.setPointerCapture(pointer);
        track.classList.add('is-dragging');
        track.focus({ preventScroll: true });
      });
      track.addEventListener('pointermove', (event) => {
        if (event.pointerId !== pointer) return;
        track.scrollLeft = originScroll + originX - event.clientX;
        event.preventDefault();
      });
      const finishDrag = (event) => {
        if (event.pointerId !== pointer) return;
        pointer = null;
        track.classList.remove('is-dragging');
        if (track.hasPointerCapture(event.pointerId)) track.releasePointerCapture(event.pointerId);
      };
      track.addEventListener('pointerup', finishDrag);
      track.addEventListener('pointercancel', finishDrag);
      track.addEventListener('lostpointercapture', finishDrag);
      track.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        const card = track.querySelector('figure');
        const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        const step = (card?.getBoundingClientRect().width || track.clientWidth) + gap;
        track.scrollBy({ left: event.key === 'ArrowRight' ? step : -step, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      });
    });
  };
  setupCampaign(document);
  document.addEventListener('shopify:section:load', (event) => setupCampaign(event.target));
})();

(() => {
  const initialize = scope => {
    const root = scope.querySelector('[data-anniversary-intro]');
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';
    const sessionKey = 'the-storage-anniversary-2026-entry';
    const preferenceKey = 'the-storage-entry-preferences-v2';
    const preview = new URLSearchParams(window.location.search).get('intro') === 'preview';
    if (root.dataset.designMode === 'true' && !preview) return;
    try { if (!preview && (sessionStorage.getItem(sessionKey) === 'seen' || window.location.hash)) return; } catch {}
    const form = root.querySelector('form');
    const language = root.querySelector('[data-anniversary-language]');
    const country = root.querySelector('[data-anniversary-country]');
    const nativeCountry = form.elements.country_code;
    const automatic = root.querySelector('[data-anniversary-auto]');
    const countdown = root.querySelector('[data-anniversary-countdown]');
    const status = root.querySelector('[data-anniversary-status]');
    const enter = root.querySelector('button[type="submit"]');
    const inertElements = [];
    let preferences = {};
    let dismissed = false;
    let submitting = false;
    let deadline = Date.now() + 12000;
    let timer;
    try { preferences = JSON.parse(localStorage.getItem(preferenceKey) || '{}') || {}; } catch {}
    const hasOption = (field, value) => field.tagName === 'SELECT' && Array.from(field.options).some(option => option.value === value);
    if (hasOption(language, preferences.language)) language.value = preferences.language;
    else if (language.tagName === 'SELECT' && window.location.pathname === '/') {
      for (const locale of navigator.languages || [navigator.language]) {
        const match = Array.from(language.options).find(option => option.value.toLowerCase() === locale.toLowerCase() || option.value.toLowerCase() === locale.toLowerCase().split('-')[0]);
        if (match) { language.value = match.value; break; }
      }
    }
    if (hasOption(country, preferences.country)) country.value = preferences.country;
    automatic.checked = preferences.automatic === true;
    const syncCountry = () => { nativeCountry.value = country.selectedOptions[0]?.dataset.countryCode || country.value; };
    syncCountry();
    const save = () => { try { localStorage.setItem(preferenceKey, JSON.stringify({language:language.value,country:country.value,automatic:automatic.checked})); } catch {} };
    const countdownTick = () => {
      countdown.hidden = !automatic.checked;
      if (!automatic.checked || submitting || dismissed) return;
      if (document.hidden || document.activeElement === language || document.activeElement === country) {
        deadline = Date.now() + 12000;
        countdown.textContent = root.dataset.paused;
        return;
      }
      const seconds = Math.max(0, Math.ceil((deadline - Date.now()) / 1000));
      countdown.textContent = root.dataset.countdown.replace('__SECONDS__', String(seconds));
      if (seconds === 0) form.requestSubmit();
    };
    const reset = () => { deadline = Date.now() + 12000; countdownTick(); };
    const close = () => {
      if (dismissed) return;
      dismissed = true;
      clearInterval(timer);
      root.classList.remove('is-playing');
      root.classList.add('is-leaving');
      document.documentElement.classList.remove('storage-anniversary-open');
      inertElements.forEach(element => { element.inert = false; });
      document.removeEventListener('keydown', onKeydown, true);
      document.getElementById('MainContent')?.focus({preventScroll:true});
      setTimeout(() => { root.hidden = true; }, 360);
    };
    const onKeydown = event => {
      if (dismissed) return;
      if (event.key === 'Escape' && event.target.tagName !== 'SELECT') { event.preventDefault(); form.requestSubmit(); return; }
      if (event.key !== 'Tab') return;
      const controls = Array.from(root.querySelectorAll('button:not(:disabled),select,input[type="checkbox"]'));
      const first = controls[0], last = controls[controls.length - 1];
      if (document.activeElement === root || (!event.shiftKey && document.activeElement === last)) { event.preventDefault(); first.focus(); }
      else if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    };
    form.addEventListener('submit', event => {
      if (submitting) { event.preventDefault(); return; }
      syncCountry(); save();
      try { sessionStorage.setItem(sessionKey, 'seen'); } catch {}
      const currentUrl = new URL(window.location.href);
      if (preview) { currentUrl.searchParams.delete('intro'); history.replaceState(null, '', currentUrl); }
      if (language.value === root.dataset.language && nativeCountry.value === root.dataset.country) { event.preventDefault(); close(); }
      else {
        submitting = true; enter.disabled = true; status.textContent = root.dataset.entering;
        const returnTo = form.querySelector('[name="return_to"]');
        const destination = new URL(root.dataset.rootUrl, window.location.origin);
        const themeId = currentUrl.searchParams.get('preview_theme_id');
        if (themeId) destination.searchParams.set('preview_theme_id', themeId);
        if (returnTo) returnTo.value = destination.pathname + destination.search;
        setTimeout(() => { if (!dismissed) { submitting = false; enter.disabled = false; reset(); } }, 8000);
      }
    });
    automatic.addEventListener('change', () => { save(); reset(); });
    [language,country].forEach(field => {
      field.addEventListener('pointerdown', reset);
      field.addEventListener('focus', reset);
      field.addEventListener('blur', reset);
      field.addEventListener('change', () => { syncCountry(); save(); reset(); });
    });
    document.addEventListener('visibilitychange', reset);
    document.addEventListener('keydown', onKeydown, true);
    root.hidden = false;
    document.documentElement.classList.add('storage-anniversary-open');
    root.focus({preventScroll:true});
    let current = root;
    while (current.parentElement) {
      for (const sibling of current.parentElement.children) {
        if (sibling !== current && sibling instanceof HTMLElement && !['STYLE','SCRIPT','LINK'].includes(sibling.tagName) && !sibling.inert) { inertElements.push(sibling); sibling.inert = true; }
      }
      current = current.parentElement;
      if (current === document.body) break;
    }
    const ready = Promise.allSettled(Array.from(root.querySelectorAll('img')).map(image => image.decode?.()));
    Promise.race([ready,new Promise(resolve => setTimeout(resolve,2200))]).then(() => {
      if (!dismissed && !window.matchMedia('(prefers-reduced-motion: reduce)').matches && !navigator.connection?.saveData) root.classList.add('is-playing');
    });
    countdownTick();
    timer = setInterval(countdownTick,250);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document), {once:true});
  else initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["storage-showroom"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('storage-showroom')) {
  class StorageShowroom extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.panels = [...this.querySelectorAll('[data-sr-panel]')].map(node => ({
        node, kind: node.dataset.srPanel, stage: node.querySelector('[data-sr-stage]'),
        pieces: [...node.querySelectorAll('[data-sr-piece]')],
        details: [...node.querySelectorAll('[data-sr-detail]')], selected: 0
      }));
      this.tabs = [...this.querySelectorAll('[data-sr-tab]')];
      this.dialog = this.querySelector('[data-sr-peek]');
      this.status = this.querySelector('[data-sr-status]');
      this.active = 0;
      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.switchPanel(index), { signal });
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
          if (event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = this.tabs.length - 1;
          if (next === undefined) return;
          event.preventDefault(); this.switchPanel(next); this.tabs[next].focus();
        }, { signal });
      });
      this.panels.forEach(group => {
        group.pieces.forEach((piece, index) => {
          piece.dataset.index = String(index);
          piece.addEventListener('focus', () => this.select(group, index, false), { signal });
          if (group.kind === 'accessories') piece.addEventListener('pointerenter', event => {
            if (event.pointerType === 'mouse') this.select(group, index, false);
          }, { signal });
        });
        let drag = null;
        let dragged = false;
        let pointerFrame = 0;
        let latestX = 0;
        group.stage.addEventListener('pointerdown', event => {
          if (event.button !== 0) return;
          dragged = false;
          drag = { x: event.clientX, y: event.clientY, index: group.selected, type: event.pointerType };
          if (event.pointerType !== 'mouse' && group.kind === 'clothing') group.stage.setPointerCapture(event.pointerId);
        }, { signal, passive: true });
        group.stage.addEventListener('pointermove', event => {
          if (drag && Math.abs(event.clientX - drag.x) > 10) dragged = true;
          if (group.kind !== 'clothing' || !group.pieces.length) return;
          if (event.pointerType !== 'mouse') {
            if (!drag) return;
            const dx = event.clientX - drag.x;
            const dy = event.clientY - drag.y;
            if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 12) this.select(group, drag.index - Math.round(dx / 62), false);
            return;
          }
          latestX = event.clientX;
          if (pointerFrame) return;
          pointerFrame = requestAnimationFrame(() => {
            pointerFrame = 0;
            const rect = group.stage.getBoundingClientRect();
            const relative = (latestX - rect.left - rect.width * .18) / (rect.width * .69);
            this.select(group, Math.round(relative * (group.pieces.length - 1)), false);
          });
        }, { signal, passive: true });
        group.stage.addEventListener('pointerup', () => { drag = null; }, { signal });
        group.stage.addEventListener('pointercancel', () => { drag = null; dragged = true; }, { signal });
        group.stage.addEventListener('click', event => {
          const piece = event.target.closest('[data-sr-piece]');
          if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
          if (dragged) { event.preventDefault(); dragged = false; return; }
          if (piece && (group.kind === 'accessories' || event.detail === 0)) this.select(group, Number(piece.dataset.index), false);
          if (piece || group.kind === 'clothing') { event.preventDefault(); this.peek(group); }
        }, { signal });
        group.stage.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = group.selected + 1;
          if (event.key === 'ArrowLeft') next = group.selected - 1;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = group.pieces.length - 1;
          if (event.key === ' ' || event.key === 'Enter') { event.preventDefault(); this.peek(group); return; }
          if (next === undefined || !group.pieces.length) return;
          event.preventDefault(); this.select(group, next, true); group.pieces[group.selected].focus({ preventScroll: true });
        }, { signal });
        signal.addEventListener('abort', () => cancelAnimationFrame(pointerFrame), { once: true });
      });
      this.querySelector('[data-sr-close]').addEventListener('click', () => this.dialog.close(), { signal });
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
      }, { signal });
      this.dialog.addEventListener('close', () => {
        this.querySelector('[data-sr-peek-content]').replaceChildren();
        this.lastFocus?.focus({ preventScroll: true });
      }, { signal });
      this.dataset.ready = 'true';
      this.switchPanel(0);
      this.observer?.disconnect();
      this.observer = new ResizeObserver(() => this.layout(this.panels[this.active]));
      this.observer.observe(this);
    }
    disconnectedCallback() { this.controller?.abort(); this.observer?.disconnect(); if (this.dialog?.open) this.dialog.close(); }
    switchPanel(index) {
      this.active = index;
      this.panels.forEach((group, i) => { group.node.hidden = i !== index; });
      this.tabs.forEach((tab, i) => { tab.setAttribute('aria-selected', String(i === index)); tab.tabIndex = i === index ? 0 : -1; });
      this.select(this.panels[index], this.panels[index].selected, false);
      this.layout(this.panels[index]);
    }
    select(group, index, announce) {
      if (!group.pieces.length) return;
      const selected = Math.max(0, Math.min(group.pieces.length - 1, index));
      if (selected === group.selected && group.initialized) return;
      group.selected = selected; group.initialized = true;
      const current = group.pieces[selected];
      group.pieces.forEach((piece, i) => { piece.tabIndex = i === selected ? 0 : -1; piece.setAttribute('aria-current', String(i === selected)); });
      group.details.forEach(detail => { detail.hidden = detail.dataset.srDetail !== current.dataset.srPiece; });
      group.node.querySelector('[data-sr-position]').textContent = `${String(selected + 1).padStart(2, '0')} / ${String(group.pieces.length).padStart(2, '0')}`;
      this.layout(group);
      if (announce) this.status.textContent = current.dataset.name;
    }
    layout(group) {
      if (!group || group.node.hidden) return;
      const width = group.stage.clientWidth;
      const mobile = width < 600;
      const pieceWidth = Math.min(mobile ? 310 : 410, width * (mobile ? .83 : .61));
      const height = Math.min(mobile ? 335 : 455, group.stage.clientHeight - 64);
      const slots = [[27,28,-12],[59,25,8],[79,43,-8],[25,67,8],[52,68,-7],[79,75,12],[44,47,-10],[75,20,10]];
      group.pieces.forEach((piece, index) => {
        const active = index === group.selected;
        if (group.kind === 'accessories') {
          const slot = slots[index % slots.length];
          piece.style.setProperty('--case-x', `${slot[0]}%`);
          piece.style.setProperty('--case-y', `${slot[1]}%`);
          piece.style.setProperty('--case-rotation', `${slot[2]}deg`);
          piece.style.setProperty('--case-size', `${Math.min(mobile ? 145 : 230, width * .36)}px`);
          piece.style.setProperty('--case-scale', active ? '1.15' : '.88');
          piece.style.setProperty('--piece-z', active ? '10' : String(index + 1));
          return;
        }
        const relative = index - group.selected;
        const distance = Math.abs(relative);
        const step = Math.min(mobile ? 45 : 68, width * .074);
        const x = active ? width * .09 : relative > 0 ? width * .33 + relative * step : width * .05 + relative * step;
        piece.style.setProperty('--piece-width', `${pieceWidth}px`);
        piece.style.setProperty('--piece-height', `${height}px`);
        piece.style.setProperty('--piece-x', `${x}px`);
        piece.style.setProperty('--piece-y', `${active ? 40 : 46 + Math.min(distance, 8) * 9}px`);
        piece.style.setProperty('--piece-angle', `${active ? -6 : relative > 0 ? -48 : 48}deg`);
        piece.style.setProperty('--piece-tilt', `${active ? -2 : relative > 0 ? 3 : -3}deg`);
        piece.style.setProperty('--piece-scale', String(active ? 1 : Math.max(.53, .85 - distance * .035)));
        piece.style.setProperty('--piece-z', active ? '30' : String(20 - distance));
        piece.style.setProperty('--piece-opacity', relative < 0 ? '.25' : '1');
      });
    }
    peek(group) {
      const piece = group.pieces[group.selected];
      if (!piece || this.dialog.open) return;
      const template = [...group.node.querySelectorAll('[data-sr-template]')].find(item => item.dataset.srTemplate === piece.dataset.srPiece);
      if (!template) return;
      this.lastFocus = document.activeElement;
      this.querySelector('[data-sr-peek-content]').replaceChildren(template.content.cloneNode(true));
      this.dialog.showModal();
      this.querySelector('[data-sr-close]').focus({ preventScroll: true });
    }
  }
  customElements.define('storage-showroom', StorageShowroom);
}

  } catch(e) { console.error(e); }
})();
})();
